import React from "react";
import { Dummyimage1 } from "../../assets/img";

const UserDetails = ({ userDetails, roomDetails }) => {
  return (
    <div className="d-flex flex-column gap-5 col-md-5 mt-0">
      <div className="roles-bg rounded-4 mt-0">
        <h2 className=" f4 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mt-2">
          User Details
        </h2>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            ID
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {userDetails?.id}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            Mobile Number
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {userDetails?.mobile_number}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Email ID
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {userDetails?.email_id}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            DOB
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {userDetails?.dob}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Booked By
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {userDetails?.booked_by}
          </p>
        </div>
      </div>
      <div className="roles-bg rounded-4  mt-0">
        <h2 className=" f4 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mt-2">
          Room Details
        </h2>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Service Type
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {roomDetails?.service_type}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Category
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {roomDetails?.category}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Images
          </p>
          <img
            alt=""
            className="view-img"
            src={roomDetails?.image ?? Dummyimage1}
          />
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Per Rooms Price
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {roomDetails?.per_rooms_price}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Extra Person Charges
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {roomDetails?.extra_person_charges}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Min Person Allowed
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : 🧑{roomDetails?.min_person_adult} 👶
            {roomDetails?.min_person_child}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Max Person Allowed
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : 🧑{roomDetails?.max_persons_adult} 👶
            {roomDetails?.max_persons_child}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
